export const SET_IS_LOADING_SCANS = 'SET_IS_LOADING_SCANS';
export const SET_SCANS_STATUS_FILTERS = 'SET_SCANS_STATUS_FILTERS';
export const CLEAR_SCANS_STATUS_FILTERS = 'CLEAR_SCANS_STATUS_FILTERS';
export const SET_SCANS_SEARCH = 'SET_SCANS_SEARCH';
export const SET_SCANS_SORT = 'SET_SCANS_SORT';
